import { mapCacheActions } from 'vuex-cache';
import moment from "moment";

const colCountByScreen2 = { xs: 1, sm: 1, md: 2, lg: 2 };

export const PeriodType = {
  data() {
    return {
      colCountByScreen2,
      periodTypeDict: null,
      dataFilter: {
        periodType: 'LAST_MONTH',
        from: moment(moment()).subtract(1, 'month').add(1, 'days').format('YYYY-MM-DD'),
        to: moment().utc().format('YYYY-MM-DD') // moment().format('YYYY-MM-DD')
      }
    }
  },
  computed: {
    calendarOptionsFrom() {
      return {
        displayFormat: 'dd.MM.yyyy',
        dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
        max: this.dataFilter.to || moment(),
        onValueChanged: this.changePeriodTypeFrom
      };
    },
  
    calendarOptionsTo() {
      return {
        displayFormat: 'dd.MM.yyyy',
        dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
        min: this.dataFilter.from || null,
        max: moment(),
        onValueChanged: this.changePeriodTypeTo
      };
    }
  },
  watch: {
    'dataFilter.periodType'(type) {
      const [from, to] = this.getPeriodRange(type);

      this.dataFilter = {
        ...this.dataFilter,
        from: from.format('YYYY-MM-DD'),
        to: to.format('YYYY-MM-DD')
      };
    },
    // 'dataFilter.from'(value) {
    //   if (moment(value).diff(this.dataFilter.to, 'days') > 0) {
    //       this.dataFilter.from = this.dataFilter.to;
    //       this.dataFilter.to = value;
    //   }
    // },
    // 'dataFilter.to'(value) {
    //   if (moment(value).diff(this.dataFilter.from, 'days') < 0) {
    //       this.dataFilter.to = this.dataFilter.from;
    //       this.dataFilter.from = value;
    //   }
    // }
  },
  methods: {
    ...mapCacheActions(['getDictionaryItems']),
    setFreeChoicePeriodType(e) {
      if (e.event) {
        const freeChoice = this.periodTypeDict.find(el => el.code === 'FREE_CHOICE');
        if (freeChoice) {
          this.dataFilter.periodType = freeChoice.code;
        }
      }
    },
    changePeriodTypeFrom(e) {
      this.setFreeChoicePeriodType(e);
    },
    changePeriodTypeTo(e) {
      this.setFreeChoicePeriodType(e);
    },
    getPeriodRange(type) {
      const now = moment();
      switch (type) {
        case 'CURRENT_WEEK':
          return [now.clone().startOf('isoWeek'), now];
        case 'CURRENT_MONTH':
          return [now.clone().startOf('month'), now];
        case 'CURRENT_QUARTER': {
          const start = now.clone().startOf('quarter');
          const end = now.clone().endOf('quarter');
          return [start, now.isAfter(end) ? end : now];
        }
        case 'CURRENT_YEAR':
          return [now.clone().startOf('year'), now];
        case 'LAST_WEEK':
          return [now.clone().subtract(1, 'week').add(1, 'day'), now];
        case 'LAST_MONTH':
          return [now.clone().subtract(1, 'month').add(1, 'day'), now];
        case 'LAST_QUARTER':
          return [now.clone().subtract(3, 'month').add(1, 'day'), now];
        case 'LAST_YEAR':
          return [now.clone().subtract(1, 'year').add(1, 'day'), now];
        case 'FREE_CHOICE':
        default:
          return [
            moment(this.dataFilter.from, 'YYYY-MM-DD'),
            moment(this.dataFilter.to, 'YYYY-MM-DD')
          ];
      }
    },
  }
}